module.exports = __webpack_public_path__ + "img/top-modal-init.b69b805b.svg";